import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  scrollToPurchase?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  scrollToPurchase = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (scrollToPurchase) {
      const offerSection = document.getElementById('offer-price');
      if (offerSection) {
        offerSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      return;
    }
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to Hotmart checkout
    window.open('https://pay.hotmart.com/S103405068E?checkoutMode=10', '_blank');
  };
  return <motion.button whileHover={{
    scale: 1.03,
    boxShadow: '0 15px 35px -8px rgba(157, 75, 107, 0.5)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-[#9d4b6b] via-[#b85d7f] to-[#9d4b6b]
        bg-[length:200%_100%]
        text-white font-bold text-base md:text-lg
        py-3.5 px-8 rounded-full 
        shadow-[0_8px_25px_-5px_rgba(157,75,107,0.4)]
        hover:shadow-[0_15px_40px_-8px_rgba(157,75,107,0.6)]
        transition-all duration-300
        flex items-center justify-center gap-2.5
        border-2 border-[#9d4b6b]/20
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} style={{
    animation: 'shimmer 3s ease-in-out infinite'
  }} data-id="element-26">
      {/* Pulsing heart icon to capture attention */}
      <Heart className="w-5 h-5 relative z-10 fill-white text-white" style={{
      animation: 'heartbeat 1.4s ease-in-out infinite'
    }} data-id="element-27" />
      <span className="relative z-10 tracking-wide" data-id="element-28">{children}</span>
      <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1.5 transition-transform duration-300" data-id="element-29" />

      {/* Animated gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-out" data-id="element-30" />
    </motion.button>;
}